"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authResponseToUrl = authResponseToUrl;
exports.loginSilent = loginSilent;
var Deferred_1 = require("../tools/Deferred");
var tsafe_1 = require("../vendor/frontend/tsafe");
var StateData_1 = require("./StateData");
var getDownlinkAndRtt_1 = require("../tools/getDownlinkAndRtt");
var isDev_1 = require("../tools/isDev");
function getIsAuthResponse(data) {
    return data instanceof Object && "state" in data && typeof data.state === "string";
}
function authResponseToUrl(authResponse) {
    var e_1, _a;
    var authResponseUrl = new URL("https://dummy.com");
    try {
        for (var _b = __values(Object.entries(authResponse)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), name_1 = _d[0], value = _d[1];
            authResponseUrl.searchParams.set(name_1, value);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return authResponseUrl.href;
}
function loginSilent(params) {
    return __awaiter(this, void 0, void 0, function () {
        var oidcClientTsUserManager, stateQueryParamValue_instance, configId, getExtraTokenParams, dResult, timeoutDelayMs, timeout, listener;
        var _this = this;
        return __generator(this, function (_a) {
            oidcClientTsUserManager = params.oidcClientTsUserManager, stateQueryParamValue_instance = params.stateQueryParamValue_instance, configId = params.configId, getExtraTokenParams = params.getExtraTokenParams;
            dResult = new Deferred_1.Deferred();
            timeoutDelayMs = (function () {
                var downlinkAndRtt = (0, getDownlinkAndRtt_1.getDownlinkAndRtt)();
                var isDev = (0, isDev_1.getIsDev)();
                // Base delay is the minimum delay we should wait in any case
                //const BASE_DELAY_MS = 3000;
                var BASE_DELAY_MS = isDev ? 9000 : 7000;
                if (downlinkAndRtt === undefined) {
                    return BASE_DELAY_MS;
                }
                var downlink = downlinkAndRtt.downlink, rtt = downlinkAndRtt.rtt;
                // Calculate dynamic delay based on RTT and downlink
                // Add 1 to downlink to avoid division by zero
                var dynamicDelay = rtt * 2.5 + BASE_DELAY_MS / (downlink + 1);
                return Math.max(BASE_DELAY_MS, dynamicDelay);
            })();
            timeout = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    dResult.resolve({
                        outcome: "failure",
                        cause: "timeout"
                    });
                    return [2 /*return*/];
                });
            }); }, timeoutDelayMs);
            listener = function (event) {
                if (!getIsAuthResponse(event.data)) {
                    return;
                }
                var authResponse = event.data;
                var stateData = (0, StateData_1.getStateData)({ stateQueryParamValue: authResponse.state });
                (0, tsafe_1.assert)(stateData !== undefined);
                (0, tsafe_1.assert)(stateData.context === "iframe");
                if (stateData.configId !== configId) {
                    return;
                }
                clearTimeout(timeout);
                window.removeEventListener("message", listener);
                dResult.resolve({
                    outcome: "got auth response from iframe",
                    authResponse: authResponse
                });
            };
            window.addEventListener("message", listener, false);
            oidcClientTsUserManager
                .signinSilent({
                state: (0, tsafe_1.id)({
                    context: "iframe",
                    configId: configId
                }),
                silentRequestTimeoutInSeconds: timeoutDelayMs / 1000,
                extraTokenParams: getExtraTokenParams === null || getExtraTokenParams === void 0 ? void 0 : getExtraTokenParams()
            })
                .then(function (oidcClientTsUser) {
                (0, tsafe_1.assert)(oidcClientTsUser !== null);
                clearTimeout(timeout);
                dResult.resolve({
                    outcome: "token refreshed using refresh token",
                    oidcClientTsUser: oidcClientTsUser
                });
            }, function (error) {
                if (error.message === "Failed to fetch") {
                    // NOTE: If we got an error here it means that the fetch to the
                    // well-known oidc endpoint failed.
                    // This usually means that the server is down or that the issuerUri
                    // is not pointing to a valid oidc server.
                    // It could be a CORS error on the well-known endpoint but it's unlikely.
                    clearTimeout(timeout);
                    dResult.resolve({
                        outcome: "failure",
                        cause: "can't reach well-known oidc endpoint"
                    });
                    return;
                }
                // NOTE: Here, except error on our understanding there can't be any other
                // error than timeout so we fail silently and let the timeout expire.
            });
            dResult.pr.then(function (result) {
                if (result.outcome === "failure") {
                    (0, StateData_1.clearStateStore)({ stateQueryParamValue: stateQueryParamValue_instance });
                }
            });
            return [2 /*return*/, dResult.pr];
        });
    });
}
//# sourceMappingURL=loginSilent.js.map